import React, { useMemo, useEffect, useRef, useCallback } from "react";
import "./ListingDetailsActions.scss";

import statisticsIcon from "./img/statistics.png";
import raiseIcon from "./img/raise.png";
import archiveIcon from "./img/archive.png";
import editIcon from "./img/edit.png";
import deleteIcon from "./img/delete.png";
import notInterestingIcon from "./img/notInteresting.png";
import messagesIcon from "./img/messages.png";

const API =
  process.env.REACT_APP_API_BASE ||
  process.env.REACT_APP_API_URL ||
  process.env.REACT_APP_API ||
  "http://localhost:5000";

const apiUrl = (path) => {
  if (!path) return String(API || "");
  if (/^https?:\/\//i.test(path)) return path;
  const base = String(API || "").replace(/\/+$/, "");
  const p = String(path || "");
  return p.startsWith("/") ? `${base}${p}` : `${base}/${p}`;
};

// утиліта як у FeedActions
function timeLeft(iso) {
  if (!iso) return "—";
  const now = Date.now();
  const t = new Date(iso).getTime();
  const diff = t - now;
  if (diff <= 0) return "завершено";
  const h = Math.floor(diff / 3_600_000);
  const m = Math.floor((diff % 3_600_000) / 60_000);
  if (h >= 24) {
    const d = Math.floor(h / 24);
    const rh = h % 24;
    return `${d} дн ${rh} год`;
  }
  return `${h} год ${m} хв`;
}

const ListingDetailsActions = ({
  isOwn,
  isLeaving,
  onClose,
  onArchive,
  onDelete,
  onEdit,
  listingType,
  onRaise,
  onNotInteresting,
  onWriteAuthor,

  raisedUntil,
  lastRaisedAt,

  listingId,
}) => {
  const safeCall = (fn, name) => {
    if (typeof fn !== "function") {
      console.warn(`❌ ListingDetailsActions: ${name} не передано або не function`);
      return;
    }
    try {
      fn();
    } catch (e) {
      console.error(`❌ ListingDetailsActions: помилка у ${name}:`, e);
    }
  };

  const leaveTimerRef = useRef(null);

  const startLeave = useCallback(() => {
    onClose?.();
  }, [onClose]);

  useEffect(() => {
    return () => {
      if (leaveTimerRef.current) clearTimeout(leaveTimerRef.current);
    };
  }, []);

  const isRaisedNow = useMemo(() => {
    const until = raisedUntil;
    if (!until) return false;
    const t = new Date(until).getTime();
    return Number.isFinite(t) && t > Date.now();
  }, [raisedUntil]);

  return (
    <div
      className={`ld-actions__backdrop ${isLeaving ? "is-leaving" : "is-open"}`}
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        className={`ld-actions__card ${isLeaving ? "is-leaving" : "is-open"}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="ld-actions__title">Дії</div>

        <div
          className={`ld-actions__list staggered ${
            isLeaving ? "is-leaving" : "is-open"
          }`}
        >
          {isOwn ? (
            <>
              {/*
<button
  className="ld-actions__item"
  onClick={() => alert("Скоро 🙂")}
  title="Статистика"
>
  <img
    src={statisticsIcon}
    alt=""
    className="ld-actions__ico ld-actions__ico--stats"
  />
  <span>Статистика</span>
</button>
*/}

              <button
                className="ld-actions__item"
                onClick={() => safeCall(onRaise, "onRaise")}
                title="Підняти оголошення"
              >
                <img src={raiseIcon} alt="" className="ld-actions__ico" />

                <span className="ld-actions__txt">
                  <span className="ld-actions__txtMain">
                    {isRaisedNow ? "Оголошення підняте" : "Підняти оголошення"}
                  </span>

                  {isRaisedNow && raisedUntil && (
                    <span className="ld-actions__txtSub">
                      залишилось {timeLeft(raisedUntil)}
                    </span>
                  )}
                </span>
              </button>

              <button
                className="ld-actions__item"
                onClick={() => safeCall(onArchive, "onArchive")}
              >
                <img src={archiveIcon} alt="" className="ld-actions__ico" />
                <span>Архівувати</span>
              </button>

              <button
                className="ld-actions__item"
                onClick={() => {
                  if (typeof onEdit === "function") {
                    onEdit(listingType);
                  } else {
                    safeCall(onEdit, "onEdit");
                  }
                }}
              >
                <img src={editIcon} alt="" className="ld-actions__ico" />
                <span>Редагувати</span>
              </button>

              <button
                className="ld-actions__item danger"
                onClick={() => {
                  if (typeof onDelete !== "function") {
                    console.warn("❌ ListingDetailsActions: onDelete не передано");
                    return;
                  }
                  console.log("🗑️ ListingDetailsActions: delete clicked");
                  try {
                    onDelete();
                  } catch (e) {
                    console.error("❌ ListingDetailsActions: помилка у onDelete:", e);
                  }
                }}
              >
                <img src={deleteIcon} alt="" className="ld-actions__ico" />
                <span>Видалити</span>
              </button>
            </>
          ) : (
            <>
              <button
                className="ld-actions__item"
                onClick={() => safeCall(onWriteAuthor, "onWriteAuthor")}
                title="Відкрити чат з автором і вставити лінк на публікацію"
              >
                <img src={messagesIcon} alt="" className="ld-actions__ico" />
                <span>Написати автору</span>
              </button>

              <button
                className="ld-actions__item"
                onClick={() => safeCall(onNotInteresting, "onNotInteresting")}
                title="Не показувати подібне частіше"
              >
                <img
                  src={notInterestingIcon}
                  alt=""
                  className="ld-actions__ico"
                />
                <span>Не цікаво</span>
              </button>
            </>
          )}
        </div>

        <button className="ld-actions__close" onClick={onClose}>
          Закрити
        </button>
      </div>
    </div>
  );
};

export default ListingDetailsActions;
